// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pagination_wrapper__3JvS3","center":"Pagination_center__ZWTx-","right":"Pagination_right__Xp4g8"};